import React from "react";
import TimeRangeComponent from "./TimeRange";

class TimeRangeEditor extends React.Component{
    constructor(props){
        super(props);
        this.dateTime = null;
        this.startTimeInputRef = React.createRef();
    }

    getValue = () => {
        return this.dateTime;
    }

    isPopup = () => {
        return true;
    }

    handleUpdate = (value) => {
        this.dateTime = value || null;
    }

    afterGuiAttached(){
         if(this.startTimeInputRef && this.startTimeInputRef.current && this.startTimeInputRef.current.inputElement){
            this.startTimeInputRef.current.inputElement.focus();
         }
    }

    render(){
        return(
           <TimeRangeComponent onChange={this.handleUpdate} {...this.props} startTimeInputRef={this.startTimeInputRef}/>
        )
    }


}

export default TimeRangeEditor;